import { DIRECTION } from "../../common/enum/direction";
import { PositionTargetProps } from "../../interface/IDefine";

function calcWidth(isMobile: boolean, bodyWidth: number, def: number|string) {
  if (isMobile) {
    return bodyWidth
  }
  return typeof def === "string" ?
    def : Math.min(def, bodyWidth);
}

function calcHeight(
  isMobile: boolean,
  headHeight: number,
  def: number|string,
  windowSize: {
    width: number;
    height: number;
  }
) {
  if (isMobile) {
    return windowSize.height - headHeight;
  }
  return typeof def === "string" ?
    "calc(" + def + " - " + headHeight + "px)" :
    Math.min(def, windowSize.height) - headHeight
}

export default function resize(
  isMobile: boolean,
  windowSize: {
    width: number;
    height: number;
  },
  body: HTMLBodyElement,
  headHeightDefinition: number|string,
  mainSizeDefinition: {
    width: number|string;
    height: number|string;
  },
  directionDefinition: DIRECTION,
  defPos: PositionTargetProps,
  collapse: boolean
) {
  if (!body) return {};
  const bodyRect = body.getBoundingClientRect();

  const headHeight = typeof headHeightDefinition === "number" ?
    Math.min(headHeightDefinition, windowSize.height) :
    0;

  const obj: {
    [key: string]: number|string;
    width: number|string;
    height: number|string;
  } = {
    width: calcWidth(isMobile, bodyRect.width, mainSizeDefinition.width),
    height: calcHeight(isMobile, headHeight, mainSizeDefinition.height, windowSize),
    [defPos.vertical.vector]: null,
    [defPos.horizontal.vector]: null,
  };

  if (directionDefinition === DIRECTION.HORIZONTAL) {
    obj[defPos.vertical.vector] = defPos.vertical.range || 0;
    obj[defPos.horizontal.vector] = collapse ? 0 : -obj.width;
  } else {
    obj[defPos.vertical.vector] = collapse ? 0 : -obj.height;
    obj[defPos.horizontal.vector] = defPos.horizontal.range || 0;
  }

  return obj;
}
